import React from "react";
import { Box, Button, Dialog, Stack, Typography } from "@mui/material";
import { COLORS } from "./constants";
import { dangerButtonSx, ghostButtonSx } from "./styles";

// ─────────────────────────────────────────────────────────────────────────────
// ConfirmDialog
//
// For actions that end something people are watching or delete data: stopping
// a live destination, deleting a video. Replaces both the stop buttons that
// acted on a single click and the browser's window.confirm, which looked
// nothing like the app and can be suppressed by the browser entirely.
//
// The safe choice is first and gets initial focus, so Enter never stops a
// broadcast by accident. The danger button names the action ("Stop YouTube")
// rather than saying "OK".
// ─────────────────────────────────────────────────────────────────────────────

export function ConfirmDialog({
  open, title, body, confirmLabel, cancelLabel = "Cancel", icon, onConfirm, onClose
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-body"
      PaperProps={{
        sx: {
          width: "100%", maxWidth: 460, m: 2, p: 3.5,
          bgcolor: COLORS.raised, backgroundImage: "none", color: COLORS.text,
          border: `1px solid ${COLORS.borderStrong}`, borderRadius: "22px",
          boxShadow: "0 32px 80px rgba(0,0,0,0.55)", textAlign: "left"
        }
      }}
      sx={{ "& .MuiBackdrop-root": { bgcolor: "rgba(8,7,24,0.72)" } }}
    >
      <Stack direction="row" spacing={2}>
        {icon && (
          <Box sx={{
            width: 44, height: 44, borderRadius: "12px", flexShrink: 0,
            bgcolor: COLORS.dangerSoft, color: COLORS.red,
            display: "flex", alignItems: "center", justifyContent: "center"
          }}>
            {icon}
          </Box>
        )}
        <Box>
          <Typography id="confirm-dialog-title" sx={{
            fontFamily: COLORS.fontDisplay, fontWeight: 700, fontSize: 20, lineHeight: 1.25
          }}>
            {title}
          </Typography>
          <Typography id="confirm-dialog-body" sx={{ mt: 1, color: COLORS.textSoft, fontSize: 14, lineHeight: 1.55 }}>
            {body}
          </Typography>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1.25} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Button autoFocus onClick={onClose} sx={ghostButtonSx}>{cancelLabel}</Button>
        <Button onClick={() => { onConfirm(); onClose(); }} sx={dangerButtonSx}>{confirmLabel}</Button>
      </Stack>
    </Dialog>
  );
}
